// Shared currency formatter. Renders a hyphen for null/undefined and for
// near-zero amounts (|val| < 0.01), otherwise a 2-decimal USD string.
export function formatCurrency(val) {
  if (val === null || val === undefined) return '-';
  if (Math.abs(Number(val)) < 0.01) return '-';
  return '$' + Number(val).toLocaleString('en-US', { minimumFractionDigits: 2, maximumFractionDigits: 2 });
}
